<template>
  <div class="page-root safe-area relative flex flex-col items-center w-full">
    <div class="left-btn absolute p-3">
      <slot name="leftBtn" />
    </div>
    <div class="right-btn absolute p-3">
      <slot name="rightBtn" />
    </div>
    <!-- Head -->
    <div class="head flex flex-col items-center mb-4 mt-24 sm:mt-40 lg:mt-56">
      <img class="mt-5 mx-5" :src="brandAsset(logoDark, logoSanne)" alt="Cloudzet" />
      <h3 v-if="headText" class="head-text mt-5 text-xl text-center">{{ headText }}</h3>
    </div>
    <!--
      Scrolling belongs in here, never on the root. The root carries the
      safe-area insets as padding, and its height is pinned by the #app flex
      chain, so padding put on a scrolling root cannot be absorbed — it lands
      in scrollHeight and shows up as a scrollbar exactly as tall as the insets.
    -->
    <div
      class="body flex flex-col items-center w-full"
      :class="{ 'overflow-y-auto': scrollContent }"
    >
      <slot name="content" />
      <c-button v-if="nextBtnText" class="my-10 text-white" @click="$emit('next')">
        {{ nextBtnText }}
      </c-button>
      <slot />
    </div>
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';
import brandMode from '@/mixins/brand-mode';
import logoDark from '@/assets/common/logo-dark.svg';
import logoSanne from '@/assets/sanne/logo.svg';

export default {
  name: 'Page',
  components: { CButton },
  mixins: [brandMode],
  data: () => ({ logoDark, logoSanne }),
  props: {
    headText: String,
    nextBtnText: String,
    back: String,
    cancel: String,
    // Let the content area scroll when it outgrows the space left under the
    // head. Off by default so pages that lay themselves out (Login floats an
    // absolute Panel in the content slot) keep behaving exactly as before.
    scrollContent: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.head-text {
  font-family: var(--font-heading);
}

.body {
  flex: 1;
  // Without this a flex item refuses to shrink below its content, so the
  // content area would push past the root instead of scrolling inside it,
  // where #app { overflow: hidden } clips the spill out of reach.
  min-height: 0;
}

.right-btn {
  // 5vh alone is 43px on a 402x874 screen, which sits under the Dynamic
  // Island. Keep it as the floor so a device reporting no inset renders exactly
  // as before, and only push down when there is an inset to clear.
  // Interpolated to keep sass out of max().
  top: #{'max(5vh, calc(var(--safe-top) + 1rem))'};
  right: 1.75rem;
}

.left-btn {
  @extend .right-btn;
  left: 1.75rem;
  right: unset;
}
</style>
